// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var MenuIcons;
(function (MenuIcons) {
    MenuIcons["ChartIcon"] = "ChartIcon";
    MenuIcons["ChartTV"] = "ChartTV";
    MenuIcons["WatchListIcon"] = "WatchListIcon";
    MenuIcons["TimeAndSalesIcon"] = "TimeAndSalesIcon";
    MenuIcons["GridIcon"] = "GridIcon";
    MenuIcons["TradingTools"] = "TradingTools";
    MenuIcons["OrderEntry"] = "OrderEntry";
    MenuIcons["OptionMaster"] = "OptionMaster";
    MenuIcons["SavedOrder"] = "SavedOrder";
    MenuIcons["MarketDepth"] = "MarketDepth";
    MenuIcons["PositionsIcon"] = "PositionsIcon";
    MenuIcons["WorkingOrder"] = "WorkingOrder";
    MenuIcons["OrderHistory"] = "OrderHistory";
    MenuIcons["FilledOrder"] = "FilledOrder";
    MenuIcons["AssetIcon"] = "AssetIcon";
    MenuIcons["PositionBalance"] = "PositionBalance";
    MenuIcons["News"] = "News";
    MenuIcons["StatementIcon"] = "StatementIcon";
    MenuIcons["HeatMapIcon"] = "HeatMapIcon";
    MenuIcons["HighLowList"] = "HighLowList";
    MenuIcons["GainersLosers"] = "GainersLosers";
    MenuIcons["AboutIcon"] = "AboutIcon";
    MenuIcons["BrokerInfo"] = "BrokerInfo";
    MenuIcons["OnboardingIcon"] = "OnboardingIcon";
    MenuIcons["DownloadLogFile"] = "DownloadLogFile";
    MenuIcons["HomePage"] = "HomePage";
    MenuIcons["TradingCentral"] = "TradingCentral";
    MenuIcons["LiveAccount"] = "LiveAccount";
    MenuIcons["ReportsIcon"] = "ReportsIcon";
    MenuIcons["ChangePasswordIcon"] = "ChangePasswordIcon";
    MenuIcons["WithdrawalIcon"] = "WithdrawalIcon";
    MenuIcons["SubscriptionsIcon"] = "SubscriptionsIcon";
    MenuIcons["AccountStatistics"] = "AccountStatistics";
    MenuIcons["CopyTrading"] = "CopyTrading";
    MenuIcons["ChangeTradingPassword"] = "ChangeTradingPassword";
    MenuIcons["CloseAccount"] = "CloseAccount";
    MenuIcons["ExternalLinkIcon"] = "ExternalLinkIcon";
    MenuIcons["AccountLookup"] = "AccountLookup";
    MenuIcons["Webhooks"] = "Webhooks";
})(MenuIcons || (MenuIcons = {}));
